import { render, staticRenderFns } from "./MultiselectReturnId.vue?vue&type=template&id=50cd074f&"
import script from "./MultiselectReturnId.vue?vue&type=script&lang=js&"
export * from "./MultiselectReturnId.vue?vue&type=script&lang=js&"
import style0 from "./MultiselectReturnId.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports